import React from 'react'

import { isNullOrUndefined, localizedDate } from '../../utils'

import AttributeTable from './AttributeTable'
import TextHighlights from './TextWithHighlight'

/**
 * ResultText component for displaying the text result with highlights and attributes.
 *
 * @see https://github.com/aws-samples/aws-kendra-transcribe-media-search/blob/main/finderapp/src/search/resultsPanel/components/ResultText.tsx
 * @example
 * const text = "Sample text"
 * const attributes = { ... }
 * const isTopResult = true
 * const lastUpdated = "2023-10-01"
 * const className = "result-text"
 * return <ResultText text={text} attributes={attributes} isTopResult={isTopResult} lastUpdated={lastUpdated} className={className} />
 *
 * @param {Object} props - The component props.
 * @param {string} props.text - The text to be displayed.
 * @param {Object} props.attributes - The attributes of the result.
 * @param {boolean} props.isTopResult - Whether the result is a top result.
 * @param {string} props.lastUpdated - The last updated date of the result.
 * @param {string} props.className - The CSS class name for the component.
 * @returns {JSX.Element} The rendered ResultText component.
 */
const ResultText = ({
  text,
  attributes,
  isTopResult,
  lastUpdated,
  className
}) => {
  const renderNotTruncated = () => {
    const answer = attributes?.hasOwnProperty('answer')
      ? attributes.answer.StringValue
      : ''
    const excerptPageNumber = attributes?.hasOwnProperty('_excerpt_page_number')
    const style = {
      // borderBottom: '1px solid rgb(224, 224, 224)',
      paddingBottom: 9,
      // borderTop: '1px solid #e0e0e0',
      marginTop: 10,
      paddingTop: 7
    }
    return (
      <span>
        {isTopResult && <h2><TextHighlights textWithHighlights={text} /></h2>}
        {excerptPageNumber && <h2><TextHighlights textWithHighlights={text} /></h2>}
        <span className="answer">{answer}</span>
        <div style={style}>
          {!attributes?.hasOwnProperty('s3_document_id') && (
            <AttributeTable attributes={attributes} />
          )}
        </div>
      </span>
    )
  }

  const renderResult = () => {
    if (isNullOrUndefined(text)) {
      return null
    }
    return renderNotTruncated()
  }

  const formatDateString = dateStr => {
    const date = localizedDate(new Date(dateStr), {
      day: '2-digit',
      month: 'short',
      year: 'numeric'
    })
    return `${date} - `
  }

  const date = lastUpdated ? formatDateString(lastUpdated) : undefined

  // const getStringAfterFirstQuestionMark = (inputString) => {
  //   const questionMarkIndex = inputString.indexOf('?');
  //
  //   if (questionMarkIndex !== -1) {
  //     // Add 1 to start the substring after the question mark
  //     return inputString.substring(questionMarkIndex + 1);
  //   } else {
  //     // If no question mark is found, return the original string
  //     return inputString;
  //   }
  // }

  return (
    <div className={className}>
      {date && <span>{date} </span>}
      <span>{renderResult()}</span>
    </div>
  )
}

export default ResultText
